import React, { Component } from 'react';
import TablePublicStock from '../components/TablePublicStock';
import SearcherPro from '../components/SearcherPro';
import { columnsPublicStock } from '../services/config';
import { connect } from 'react-redux';
import { flagLoading, getStock } from '../../actions';
import { getStockData } from '../../common/store/reducers/stock'
import { filterStockDataByText } from '../services/filterStockData';
import { Typography } from '@material-ui/core';

class PublicStockContainer extends Component {
    constructor () {
        super();
        this.state = {
            searchData: {
                text: ""
            }
        }
    }

    componentDidMount() {
        const { stock, getStock } = this.props;

        if (stock.length === 0) {
            getStock();
        }
    }

    handleSearchText = text => {
        const searchData = { text }
        this.setState({ ...this.state, searchData })
    }

    getStockDataFilter = stock => {
        const stockData = getStockData(stock)
        return filterStockDataByText(stockData, this.state.searchData.text)
    }

    render () {
        const { stock, loading } = this.props;
        const { text: textSearch } = this.state.searchData
        const isMobile = window.matchMedia('(max-width:600px)').matches;

        return (
            <div style={{ padding: '20px 20px 20px 20px' }}>
                <SearcherPro
                    textSearch={textSearch}
                    handleChangeTextSearch={this.handleSearchText}
                />
                <TablePublicStock
                    loading={loading}
                    columns={columnsPublicStock}
                    data={this.getStockDataFilter(stock)}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getStock: payload => dispatch(getStock(payload)),
    flagLoading: payload => dispatch(flagLoading(payload))
})

const mapStateToProps = state => ({
    stock: state.stock.data,
    loading: state.stock.loading
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicStockContainer);